import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "../views/Home.vue";
// import Cinema from "../views/Cinema.vue";
// import FirstDiagram from "../views/FirstDiagram.vue"
// import Ova from "../views/ova.vue"
// import About from "../views/About.vue"
import Diagram from "../components/Diagram.vue"

import Page404 from "../views/404"
Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: "/about",
    children: [
      {
        path: '/about',
        name: 'About',
        component: resolve=>(require(["@/views/About"],resolve)),
      },
      {
        path: '/Cinema',
        name: 'Cinema',
        component: resolve=>(require(["@/views/Cinema"],resolve)),
      },
       {
        path: '/FirstDiagram',
        name: 'FirstDiagram',
        component: resolve=>(require(["@/views/FirstDiagram"],resolve)),
      },
      {
        path: '/Ova',
        name: 'Ova',
        component:resolve=>(require(["@/views/ova"],resolve)),
      },
      {
        path: '/Diagram',
        name: 'diagram',
        component: Diagram,
      }
    ]
  },
  {
    path: '/FirstDiagram1',
    name: 'FirstDiagram1',
    component: resolve=>(require(["@/views/FirstDiagram1"],resolve)),
  },
  {
    path: '*',
    name: '404',
    component: Page404
  },

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
 
})
 
export default router

